import { connect } from 'react-redux';

import { IState } from '../../../store/reducer';
import { ContentHeaderComponent } from './ContentHeader';

const mapStateToProps = (state: IState) => ({
	impersonating: state.entities.admin.isImpersonating
});

export const ContentHeader = connect(mapStateToProps)(ContentHeaderComponent);
